import { render } from "./PrimaryInsights.vue?vue&type=template&id=558e765c&ts=true"
import script from "./PrimaryInsights.vue?vue&type=script&lang=ts"
export * from "./PrimaryInsights.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__